import { ReactNode } from 'react'

import clsx from 'clsx'

import { isDevelopment } from '@/utils/isDevelopment'

import { ShareLinks } from '@/components/ShareLinks'

import { ResolvedField } from '../../../../lib/contentful/utils'

type Props = {
	className?: string
	heading?: ReactNode
	titleField: ResolvedField
	slugField: ResolvedField
	baseUrl?: string
	color?: string
}

const Warning = ({ className, children }: { className?: string; children: ReactNode }) => (
	<p className={clsx('text py-4 text-center text-gray-700', className)}>{children}</p>
)

export function ContentfulShareLinks({
	className,
	heading,
	titleField,
	slugField,
	color,
	baseUrl
}: Props) {
	if ('error' in titleField) {
		if (isDevelopment()) return <Warning className={className}>{titleField.error}</Warning>
		return null
	}
	if ('error' in slugField) {
		if (isDevelopment()) return <Warning className={className}>{slugField.error}</Warning>
		return null
	}
	if (typeof titleField.data !== 'string') {
		if (isDevelopment()) return <Warning className={className}>Title is not a string.</Warning>
		return null
	}
	if (typeof slugField.data !== 'string') {
		if (isDevelopment()) return <Warning className={className}>Slug is not a string.</Warning>
		return null
	}

	return (
		<ShareLinks
			className={className}
			color={color}
			url={`${baseUrl}/${slugField.data}`}
			title={titleField.data}
			heading={heading}
		/>
	)
}
